export function generateInvoiceNumber() {
  const date = new Date();
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");

  const counterKey = `invoice_counter_${y}${m}${d}`;
  let counter = Number(localStorage.getItem(counterKey) || 0) + 1;
  localStorage.setItem(counterKey, counter);

  return `INV-${y}${m}${d}-${String(counter).padStart(4, "0")}`;
}